import { getShapeDividersCSSVars } from '../../core/carmi/ShapeDividers/ShapeDividers.mapper'
import type { StripColumnsContainerCss, StripColumnsContainerDefinition } from '@wix/thunderbolt-components-native'
import { withCompInfo } from '@wix/editor-elements-integrations'
import { getFillLayersCSSVars } from '../../core/mappers/FillLayers/FillLayers.utils'
import type { CompDesign } from '../../core/carmi/ShapeDividers/ShapeDividers.utils'
import { getCompDesignPerVariant } from '../../core/carmi/ShapeDividers/ShapeDividers.utils'

export const css = withCompInfo<StripColumnsContainerCss, StripColumnsContainerDefinition>()(
	[
		'hasResponsiveLayout',
		'structure',
		'compDesign',
		'compProps',
		'experiments',
		'isMobileView',
		'siteColors',
		'viewMode',
		'compId',
		// @ts-ignore - Remove once siteWidth is added to the compInfo
		'siteWidth',
		// @ts-ignore - Remove once animations is added to the compInfo
		'animations',
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		'isNonAdaptiveMobile',
		'isOneDocMigrated',
	],
	({
		hasResponsiveLayout,
		structure,
		compDesign,
		compProps,
		experiments,
		isMobileView,
		siteColors,
		viewMode,
		compId,
		// @ts-ignore - Remove once animations is added to the compInfo
		animations,
		// @ts-ignore - Remove once siteWidth is added to the compInfo
		siteWidth,
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		isNonAdaptiveMobile,
		isOneDocMigrated,
	}) => {
		const compDesignPerVariantMap = getCompDesignPerVariant(compDesign)
		const defaultDesign = compDesignPerVariantMap[''] as CompDesign
		const backgroundMedia = defaultDesign?.background || {}
		const numberOfColumns = (structure.components || []).length

		const minWidth = isMobileView || isOneDocMigrated ? {} : { 'min-width': `${siteWidth}px` }

		const dividersCSSVars = getShapeDividersCSSVars({
			compId,
			hasResponsiveLayout,
			isMobileView,
			compDesignPerVariantMap,
			colorsMap: siteColors,
		})

		const fillLayersCss = getFillLayersCSSVars({
			animations,
			backgroundMedia,
			compId,
			compDesign,
			compProps,
			experiments,
			isMobileView,
			isNonAdaptiveMobile,
			siteColors,
			viewMode,
		})

		const padding = compProps.rowMargin
		const gap = compProps.columnsMargin
		const totalPadding = padding * 2
		const totalGap = gap * (numberOfColumns - 1)
		const siteWidthDelta = isOneDocMigrated
			? {
				'--site-width-delta': `${totalPadding + totalGap}px`,
			}
			: {}

		return {
			...siteWidthDelta,
			...dividersCSSVars,
			...fillLayersCss,
			'--padding': `${padding}px`,
			'--margin': `${gap}px`,
			...minWidth,
		}
	}
)
